<svelte:options runes={false} />

<script>
  export let eyebrow;
  export let title;
</script>

<div class="section-heading">
  <div>
    <p class="eyebrow">{eyebrow}</p>
    {#if title}<h2>{title}</h2>{/if}
    <slot />
  </div>
  <slot name="trailing" />
</div>
